import { Field, Pill, TextField } from "components/commons";
import styles from "./order-summary.module.scss";
import { useFormContext } from "contexts/form-context";
import locale from "localization";
import { OrderStatus } from "enums";
import { ViewRow } from "../components/view-row";
import {
  prettifyDeliveryRecipient,
  prettifyOrderStatus,
  prettifyProductType,
} from "utils/pretty.utils";
import { dateTimeFormat } from "utils";

const OrderSummaryInformationForm = ({ orderSummary, loading }) => {
  const { order } = orderSummary || {};
  const { fields, modifyField } = useFormContext();

  return (
    <>
      <ViewRow
        label={locale.status}
        value={
          <Pill
            className={styles.status}
            cheddar={
              order?.status === OrderStatus.ForRevision || order?.status === OrderStatus.Pending
            }
            grass={order?.status === OrderStatus.Delivered}
            cement={order?.status === OrderStatus.Canceled}
            deepRed={order?.status === OrderStatus.Rejected}
            sky={order?.status === OrderStatus.Processing}
            purple={order?.status === OrderStatus.ForDelivery}
            mainlyBlue={order?.status === OrderStatus.ForApproval}
          >
            {prettifyOrderStatus(order?.status)}
          </Pill>
        }
        loading={loading}
      />
      <ViewRow label={locale.stationCode} value={order?.stationCode ?? "-"} loading={loading} />
      <ViewRow label={locale.stationName} value={order?.station?.name ?? "-"} loading={loading} />
      <ViewRow label={locale.stationType} value={order?.station?.type ?? "-"} loading={loading} />
      <ViewRow
        label={locale.orderRecipient}
        value={prettifyDeliveryRecipient(order?.recipient)}
        loading={loading}
      />
      <ViewRow
        label={locale.preferredDeliveryDateTime}
        value={dateTimeFormat(order?.preferredDeliveryDate) ?? ""}
        loading={loading}
      />

      <Field
        {...fields.purchaseOrderNumber}
        label={locale.purchaseOrderNumber}
        labelPosition={"left"}
        labelClassName={styles.fieldLabel}
        childrenClassName={styles.fieldContent}
      >
        <TextField {...fields.purchaseOrderNumber} onChange={modifyField} />
      </Field>
      <Field
        {...fields.salesOrderNumber}
        label={locale.salesOrderNumber}
        labelPosition={"left"}
        labelClassName={styles.fieldLabel}
        childrenClassName={styles.fieldContent}
      >
        <TextField {...fields.salesOrderNumber} onChange={modifyField} />
      </Field>
      <Field
        {...fields.remarks}
        label={locale.remarks}
        labelPosition={"left-start-aligned"}
        labelClassName={styles.fieldLabel}
      >
        <div className={styles.remarks}>
          <TextField
            multiline
            {...fields?.remarks}
            value={order?.remarks}
            onChange={modifyField}
            disabled={true}
          />
        </div>
      </Field>
      <ViewRow
        label={locale.productType}
        value={prettifyProductType(order?.productType) ?? "-"}
        loading={loading}
      />
    </>
  );
};

export default OrderSummaryInformationForm;
